if (typeof window.Promise !== "function") {
  require("es6-promise").polyfill();
}

if (process.env.NODE_ENV !== "production") {
  console.log("Looks like we are in development mode!");
}

require("regenerator-runtime/runtime");

// disabled due to too many errors
// import * as Sentry from '@sentry/react';
// Sentry.init({
//   dsn: 'https://eed5ac909da74e94819e9a42fb6055f5@o68915.ingest.sentry.io/1319143',
//   environment: process.env.NODE_ENV,
// });
// const sentryReduxEnhancer = Sentry.createReduxEnhancer({
//   actionTransformer: action => {
//     if (action.type === LOGIN_SUCCESS) return null;
//
//     return action;
//   },
// });

import "react-widgets/dist/css/react-widgets.css";
import "./css/style.css";

import React from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { IntlProvider } from "react-intl";
import { Grid, Row, Col } from "react-bootstrap";
import { Provider } from "react-redux";
import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import { Router, Route, Switch, useHistory } from "react-router";
import createBrowserHistory from "history/createBrowserHistory";
import { reducer as formReducer } from "redux-form";

import { ReactGA, analyticsMiddleware } from "./analytics";

import { fetchProfile, fetchWatchlist } from "./actions/index";
import { AlertsPage } from "./components/alerts-page";
import { Homepage } from "./components/homepage";
import { FAQ } from "./components/faq";
import Popups from "./components/popups";
import Navbar from "./components/nav-bar";
import { Footer } from "./components/footer";
import HistoricalReport from "./components/historical-report";
import Watchlist from "./components/watchlist";
import { PremiumPage } from "./components/premium";
import Register from "./components/register";
import { FilterStocks } from "./components/filter";
import About from "./components/about";
import ChangeLog from "./components/changelog";
import MessageBox from "./components/message-box";
import { PatreonCta } from "./components/patreon-cta";
import {
  StockReducer,
  CompanySearchReducer,
  TrendingReducer,
  WatchlistReducer,
  AuthReducer,
  MessageReducer,
  FilteredStocksReducer,
  alertReducer,
} from "./reducers/index";
import { defaultQueryFn } from "./http";

const reducer = combineReducers({
  alerts: alertReducer,
  stock: StockReducer,
  companies: CompanySearchReducer,
  trending: TrendingReducer,
  form: formReducer,
  auth: AuthReducer,
  watchlist: WatchlistReducer,
  message: MessageReducer,
  filteredStocks: FilteredStocksReducer,
});

const store = createStore(
  reducer,
  localStorage.getItem("token")
    ? { auth: { authenticated: true, showLogin: false } }
    : {},
  compose(
    applyMiddleware(thunk, analyticsMiddleware),
    // sentryReduxEnhancer,
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f
  )
);

if (store.getState().auth.authenticated) {
  store.dispatch(fetchProfile());
  store.dispatch(fetchWatchlist());
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
    },
  },
});

function logPageView() {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
}

const Routes = () => {
  const history = useHistory();

  React.useEffect(() => {
    logPageView();
    history.listen(logPageView);
  }, [history]);

  return (
    <Switch>
      <Route exact path="/" component={Homepage} />
      <Route path="/report/:ticker" component={HistoricalReport} />
      <Route path="/watchlist" component={Watchlist} />
      <Route path="/alerts" component={AlertsPage} />
      <Route path="/premium" component={PremiumPage} />
      <Route path="/register" component={Register} />
      <Route path="/filter" component={FilterStocks} />
      <Route path="/about" component={About} />
      <Route path="/faq" component={FAQ} />
      <Route path="/changelog" component={ChangeLog} />
    </Switch>
  );
};

const App = () => {
  return (
    <IntlProvider messages={{}} locale="en" timeZone="America/New_York">
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Router history={createBrowserHistory()}>
            <PatreonCta />
            <Grid>
              <Row>
                <Col>
                  <Navbar />
                  <Popups />
                  <MessageBox />
                  <Routes />
                </Col>
              </Row>
              <Footer />
            </Grid>
          </Router>
        </Provider>
      </QueryClientProvider>
    </IntlProvider>
  );
};

ReactDOM.render(App(), document.querySelector(".container"));
